import styled from "styled-components";
import { colors } from "../../../theme/colors";

export const DotButton = styled.button`
  background-image: url(${({ bgImage }) => bgImage});
  background-size: cover;
  background-position: center;
  border: 3px solid ${({ active }) => (active ? colors.primary : "transparent")};
  border-radius: 50%;
  width: 60px;
  height: 60px;
  margin: 0.5rem 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: ${({ active }) =>
      active ? "rgba(0, 0, 0, 0.3)" : "rgba(0, 0, 0, 0.5)"};
    border-radius: 50%;
    z-index: 1;
  }

  .icon {
    position: relative;
    z-index: 2;
    color: white;
    font-size: 2rem;
  }

  .icon path {
    fill: #ffffff;
  }

  &:hover {
    transform: scale(1.1);
    border-color: ${colors.primary};
  }
`;

export const CarouselContainer = styled.div`
  display: flex;
  gap: 2rem;
  align-items: stretch;
  justify-content: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;

  .main-content {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 0;
  }

  .dots-container {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    justify-content: center;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;

    .dots-container {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      justify-content: center;
      display: none !important;
    }
  }
`;

export const StackedImageContainer = styled.div`
  position: relative;
  width: 320px;
  height: 574px;
  margin: 0 auto;
  perspective: 1000px;

  .image-stack {
    position: absolute;
    border-radius: 8px;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
    transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
  }

  .image-1 {
    width: 85%;
    height: 90%;
    top: 5%;
    left: 0;
    z-index: 1;
    background: #e0e0e0;
    transform: rotate(-2deg) translateZ(-50px);
  }

  .image-2 {
    width: 90%;
    height: 85%;
    top: 8%;
    left: 5%;
    z-index: 2;
    background: #f5f5f5;
    transform: rotate(1deg) translateZ(-25px);
  }

  .image-3 {
    width: 95%;
    height: 90%;
    top: 10%;
    left: 15%;
    z-index: 3;
    transform: rotate(0deg) translateZ(0px);
    opacity: 1;
  }

  .main-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    border-radius: 8px;
    transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  }

  &.changing .image-3 {
    transform: rotate(0deg) translateZ(-100px) scale(0.9);
    opacity: 0;
  }

  &.changing .image-2 {
    transform: rotate(1deg) translateZ(-75px) scale(0.95);
  }

  &.changing .image-1 {
    transform: rotate(-2deg) translateZ(-100px) scale(0.9);
  }

  @media (max-width: 768px) {
    width: 240px;
    height: 430px;
    perspective: 800px;
  }

  @media (max-width: 480px) {
    width: 200px;
    height: 358px;
    perspective: 600px;
  }
`;

export const MainContentContainer = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 3rem;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;

  .image-section {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .text-section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 400px;
    padding-left: 2rem;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;

    .text-section {
      min-height: 200px;
      order: 2;
      padding-left: 0;
      text-align: center;
    }

    .image-section {
      order: 1;
    }
  }
`;

export const TextContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: all 0.4s ease;

  .title {
    min-height: 80px;
    display: flex;
    align-items: flex-start;
    margin-bottom: 1rem;
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  .description {
    min-height: 100px;
    display: flex;
    align-items: flex-start;
    margin-bottom: 2rem;
    line-height: 1.6;
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  .download-links {
    margin-top: auto;
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  &.changing .title,
  &.changing .description,
  &.changing .download-links {
    opacity: 0.7;
    transform: translateX(-10px);
  }

  @media (max-width: 768px) {
    .title {
      min-height: 60px;
    }

    .description {
      min-height: 80px;
      margin-bottom: 1.5rem;
    }

    .download-links {
      align-items: center;
      justify-content: center;
    }
  }
`;
